/* Jozour best sellers tabs (sections/jz-bs-tabs.liquid) */
(function(){
  function init(root){
    if(root.__jzb)return;root.__jzb=1;
    var tabs=[].slice.call(root.querySelectorAll('[data-jzb-tab]'));
    var cards=[].slice.call(root.querySelectorAll('[data-jzb-group]'));
    var bar=root.querySelector('.jzb-tabs');
    var strip=root.querySelector('.jzb-tabs__in');
    var grid=root.querySelector('[data-jzb-grid]');
    var more=root.querySelector('[data-jzb-more]');
    var hdr=document.querySelector('.t4s-section-header');
    if(!tabs.length||!bar||!grid)return;
    /* limit = products shown per tab (0 = all). deep = the page link carries the open tab (#key or ?tab=key). */
    var limit=parseInt(root.getAttribute('data-jzb-limit'),10)||0;
    var deep=root.hasAttribute('data-jzb-deeplink');
    var pinned=!root.classList.contains('jzb--static');
    function keyOf(t){return t.getAttribute('data-jzb-tab')}
    function ord(c){return parseInt(c.style.order,10)||0}
    function topOffset(){
      var b=0;
      if(hdr){var p=getComputedStyle(hdr).position;if(p==='sticky'||p==='fixed'){b=Math.max(0,Math.round(hdr.getBoundingClientRect().bottom))}}
      return b;
    }
    function setTop(){root.style.setProperty('--jzb-top',topOffset()+'px')}
    /* centre the open tab inside the strip without moving the page */
    function centre(t){
      if(!strip)return;
      var d=t.getBoundingClientRect().left-strip.getBoundingClientRect().left-(strip.clientWidth-t.offsetWidth)/2;
      strip.scrollLeft+=d;
    }
    function activate(key,user){
      var ok=false;
      tabs.forEach(function(t){if(keyOf(t)===key)ok=true});
      if(!ok)key='all';
      tabs.forEach(function(t){
        var on=keyOf(t)===key;
        t.classList.toggle('is-on',on);
        if(on){t.setAttribute('aria-current','true');centre(t)}
        else{t.removeAttribute('aria-current')}
      });
      var list=[];
      cards.forEach(function(c){
        if(key==='all'||c.getAttribute('data-jzb-group')===key)list.push(c);
        else c.classList.add('is-off');
      });
      if(limit>0)list.sort(function(a,b){return ord(a)-ord(b)});
      list.forEach(function(c,i){c.classList.toggle('is-off',limit>0&&i>=limit)});
      if(more)more.setAttribute('href',more.getAttribute('data-jzb-more')+(key==='all'?'':'#'+key));
      if(user){
        if(deep){try{history.replaceState(null,'',key==='all'?location.pathname+location.search:'#'+key)}catch(e){}}
        var y=grid.getBoundingClientRect().top-topOffset()-bar.offsetHeight-8;
        if(pinned&&y<0)window.scrollBy(0,y);
      }
    }
    tabs.forEach(function(t){t.addEventListener('click',function(e){e.preventDefault();activate(keyOf(t),true)})});
    var start='all';
    if(deep){
      var q='';
      try{q=new URLSearchParams(location.search).get('tab')||''}catch(e){}
      start=(q||location.hash.replace('#','')||'all').toLowerCase();
      window.addEventListener('hashchange',function(){activate((location.hash.replace('#','')||'all').toLowerCase(),false)});
    }
    activate(start,false);
    if(pinned){
      setTop();
      var tick=false;
      window.addEventListener('scroll',function(){if(tick)return;tick=true;requestAnimationFrame(function(){setTop();tick=false})},{passive:true});
      window.addEventListener('resize',setTop);
    }
  }
  function boot(){[].forEach.call(document.querySelectorAll('[data-jzb]'),init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
